// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33mnH","left":"styles_left__R7NbO","desktopActions":"styles_desktopActions__2ybtf","title":"styles_title__2vWMY"};